export const TEST_ID = 'formSubmitPanel';
